import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
type UseKeyboardNavigationOptions<T> = {
  items: T[];
  onSelect: (item: T, index: number) => void;
  onClose: () => void;
  resetDeps?: unknown[];
};
export function useKeyboardNavigation(t0) {
  const $ = _c(21);
  const {
    items,
    onSelect,
    onClose,
    resetDeps: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const resetDeps = t2;
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const itemRefs = useRef(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setSelectedIndex(0);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== items.length || $[5] !== resetDeps) {
    t5 = [items.length, ...resetDeps];
    $[4] = items.length;
    $[5] = resetDeps;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[7] !== items || $[8] !== onClose || $[9] !== onSelect || $[10] !== selectedIndex) {
    t6 = () => {
      const handled = _temp;
      const handleKeyDown = e_0 => {
        if (items.length === 0) {
          return;
        }
        bb12: switch (e_0.key) {
          case "ArrowDown":
            {
              handled(e_0);
              setSelectedIndex(prev_0 => Math.min(prev_0 + 1, items.length - 1));
              break bb12;
            }
          case "ArrowUp":
            {
              handled(e_0);
              setSelectedIndex(_temp2);
              break bb12;
            }
          case "Enter":
            {
              if (e_0.shiftKey || e_0.isComposing) {
                return;
              }
              handled(e_0);
              if (selectedIndex >= 0 && selectedIndex < items.length) {
                onSelect(items[selectedIndex], selectedIndex);
              }
              break bb12;
            }
          case "Escape":
            {
              handled(e_0);
              onClose();
            }
        }
      };
      document.addEventListener("keydown", handleKeyDown, true);
      return () => document.removeEventListener("keydown", handleKeyDown, true);
    };
    t7 = [items, selectedIndex, onSelect, onClose];
    $[7] = items;
    $[8] = onClose;
    $[9] = onSelect;
    $[10] = selectedIndex;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[13] !== selectedIndex) {
    t8 = () => {
      const selectedElement = itemRefs.current[selectedIndex];
      if (selectedElement) {
        selectedElement.scrollIntoView({
          block: "nearest",
          behavior: "smooth"
        });
      }
    };
    t9 = [selectedIndex];
    $[13] = selectedIndex;
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  useEffect(t8, t9);
  let t10;
  if ($[16] !== selectedIndex) {
    t10 = index => ({
      ref: el => {
        itemRefs.current[index] = el;
      },
      onMouseEnter: () => setSelectedIndex(index),
      isSelected: index === selectedIndex
    });
    $[16] = selectedIndex;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const getItemProps = t10;
  let t11;
  if ($[18] !== getItemProps || $[19] !== selectedIndex) {
    t11 = {
      selectedIndex,
      setSelectedIndex,
      getItemProps
    };
    $[18] = getItemProps;
    $[19] = selectedIndex;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp2(prev) {
  return Math.max(prev - 1, 0);
}
function _temp(e) {
  e.preventDefault();
  e.stopPropagation();
}